import React, { useState, useRef } from 'react';
import { Autocomplete, TextField, Chip, Box } from '@mui/material';

export default function SoftwareTagInput({
  value = [],
  onChange,
  pool = [],
  onAddNew,
  label = 'Programvaror',
  placeholder = 'Sök eller lägg till programvara...',
  size = 'small',
}) {
  const [inputValue, setInputValue] = useState('');
  const recentlyAdded = useRef(new Set());

  const options = pool.filter(
    p => !value.some(v => v.toLowerCase() === p.toLowerCase())
  );

  function handleAdd(name) {
    const trimmed = (name || '').trim();
    if (!trimmed) return;
    const key = trimmed.toLowerCase();
    // Guard against double-fire from Autocomplete (onChange + onKeyDown both trigger on Enter)
    if (recentlyAdded.current.has(key)) { setInputValue(''); return; }
    if (value.some(v => v.toLowerCase() === key)) { setInputValue(''); return; }
    recentlyAdded.current.add(key);
    setTimeout(() => recentlyAdded.current.delete(key), 300);
    onChange([...value, trimmed]);
    if (!pool.some(p => p.toLowerCase() === key) && onAddNew) {
      onAddNew(trimmed);
    }
    setInputValue('');
  }

  return (
    <Box>
      {value.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1 }}>
          {[...value].sort((a, b) => a.localeCompare(b, 'sv')).map(v => (
            <Chip
              key={v}
              label={v}
              size="small"
              sx={{
                bgcolor: '#e3f2fd',
                color: '#1565c0',
                '& .MuiChip-deleteIcon': { color: '#1565c0' },
              }}
              onDelete={() => onChange(value.filter(item => item !== v))}
            />
          ))}
        </Box>
      )}
      <Autocomplete
        freeSolo
        size={size}
        options={options}
        inputValue={inputValue}
        onInputChange={(_, v) => setInputValue(v)}
        onChange={(_, newVal) => {
          if (newVal) handleAdd(typeof newVal === 'string' ? newVal : String(newVal));
        }}
        renderInput={params => (
          <TextField
            {...params}
            size={size}
            label={label}
            placeholder={placeholder}
            onKeyDown={e => {
              if (e.key === 'Enter' && inputValue.trim()) {
                e.preventDefault();
                handleAdd(inputValue);
              }
            }}
          />
        )}
      />
    </Box>
  );
}
